/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Actions from './Actions/index'
import React from 'react'
import Sections from './Sections/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content"
  
}) {
  return (<React.Fragment
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
<Sections
  viewPath={`${viewPath}/Sections`}
/>
{children}
</React.Fragment>)
}